$(document).ready(function () {
  const $dropDownNavLinks = $('[js-data="data-has-dropdowns"]')
  const $searchLink = $('[js-data="search-link"]')

  const $searchForm = $('[js-data="search-form"]')
  $dropDownNavLinks.each((index, navLink) => {
    $(navLink).on('mouseenter mouseleave', toggleMegaMenu)
  })

  $searchLink.on('click', (e) => {
    e.preventDefault()
    toggleSearchForm(e.currentTarget) 
  })

  
  // this is a global mouseup event to close the search dropdown when clicking outside of the search dropdown
  // need to research if there's a better way to do this

  $(document).mouseup((e) => {
    if(!$searchForm.is(e.target) && $searchForm.has(e.target).length === 0) {
      resetSearchForm()
    }
  })

  $(document).on('touchend', (e) => {
    if(!$searchForm.is(e.target) && $searchForm.has(e.target).length === 0) {      
      resetSearchForm()
    }
  })


  function toggleSearchForm(searchLinkEle) {
    let $searchForm = $(searchLinkEle).prev('[js-data="search-form"]')
    // if ($searchForm.length === 0 ) {
    //   $searchForm = $('[js-data="search-dropdown-container"]')
    // }
    $(searchLinkEle).toggleClass('disabled')
    $searchForm.toggleClass('active')
  }

  function toggleMegaMenu(e) {    
    const $megaMenuContainer = $(this).find('[js-data="mega-menu-container"]')
    const $searchLink = $('[js-data="search-link"]')
    
    $megaMenuContainer.toggleClass('site-nav__mega-menu-container--active')

    if ($searchLink) {
      resetSearchForm($searchLink)
    }
  }

  function resetSearchForm() {     
    
    $searchForm.removeClass('active')
    $searchLink.removeClass('disabled')
  }

})